var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaystack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10991",
    "data-name": "Group 10991",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8656",
    "data-name": "Rectangle 8656",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 4.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10066",
    "data-name": "Path 10066",
    d: "M-118.556,232.2h-11.9a.755.755,0,0,0-.74.755V234.3a.755.755,0,0,0,.74.755h11.9a.768.768,0,0,0,.755-.755V232.97A.762.762,0,0,0-118.556,232.2Zm0,7.477h-11.9a.7.7,0,0,0-.518.222.727.727,0,0,0-.222.533v1.347a.755.755,0,0,0,.74.755h11.9a.758.758,0,0,0,.755-.755v-1.347A.758.758,0,0,0-118.556,239.677Zm-5.2,3.731h-6.707a.694.694,0,0,0-.518.222.79.79,0,0,0-.222.533v1.347a.755.755,0,0,0,.74.755h6.692a.742.742,0,0,0,.74-.74v-1.347A.712.712,0,0,0-123.753,243.408Zm5.952-7.477H-130.46a.694.694,0,0,0-.518.222.79.79,0,0,0-.222.533v1.347a.755.755,0,0,0,.74.755h12.644a.746.746,0,0,0,.74-.755v-1.347A.743.743,0,0,0-117.8,235.931Zm0,0",
    transform: "translate(145.138 -218.233)",
    fill: "#00c3f7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystack);
export default __webpack_public_path__ + "static/media/paystack.0ff77e02e34bc813125530649fc6ea5b.svg";
export { ForwardRef as ReactComponent };